// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gameGoalMain {
  background-color: #07405e;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  position: fixed;
  overflow-y: auto;
}
.gameGoalMain .gameGoalContainer {
  height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 97%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .gameGoalMain .gameGoalContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .gameGoalMain .gameGoalContainer {
    height: 100%;
  }
}
.gameGoalMain .gameGoalContainer .gameGoalHeader, .gameGoalMain .gameGoalContainer .gameGoalText {
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  width: 90%;
}
.gameGoalMain .gameGoalContainer .gameGoalHeader {
  text-align: center;
  font-size: 25px;
}`, "",{"version":3,"sources":["webpack://./src/modules/settings/gameGoal/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAEA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AACI;EAIE,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;AALN;AAPQ;EADJ;IAEM,YAAA;EAUR;AACF;AARM;EALF;IAMM,YAAA;EAWR;AACF;AAHM;EACE,cC3BK;ED4BL,iCEvBC;EFwBD,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,UAAA;AAIR;AAFI;EACI,kBAAA;EACA,eAAA;AAIR","sourcesContent":["@import '../../../scss/colors.scss';\n@import '../../../scss/fonts.scss';\n.gameGoalMain{\n    background-color: #07405e;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100dvh;\n    position: fixed;\n    overflow-y: auto;\n    .gameGoalContainer {\n        @media (min-width: 450px){\n          width: 400px;\n      }\n      height: 85%;\n      @media only screen and (max-height: 712px) {\n          height: 100%;\n      }\n      display: flex;\n      align-items: center;  \n      flex-direction: column;\n      width: 97%;\n      height: 100dvh;\n      padding: 10px;\n\n      .gameGoalHeader , .gameGoalText{\n        color: $color-White;\n        font-family: $Roboto;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 25px;\n        // position: absolute;\n        width: 90%;\n    }\n    .gameGoalHeader{\n        text-align: center;\n        font-size: 25px;\n      }\n    }\n\n}","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
